import script from "./UniversalDateList.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalDateList.vue?vue&type=script&setup=true&lang=js"

import "./UniversalDateList.vue?vue&type=style&index=0&id=4ee53780&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee53780"]])

export default __exports__